import React, { useState } from 'react';
import MetaBudgetIncreaseSection from './MetaBudgetIncreaseSection';
import MetaCampaignTrackingSection from './MetaCampaignTrackingSection';
import MetaBalanceReductionSection from './MetaBalanceReductionSection';
import MetaNoContactSection from './MetaNoContactSection';
import MetaCostIncreaseSection from './MetaCostIncreaseSection';
import MetaVerificationsSection from './MetaVerificationsSection';
import MetaNoAnswerSection from './MetaNoAnswerSection';
import MetaBudgetReviewSection from './MetaBudgetReviewSection';

const MetaSection = ({ currentUser }) => {
  const [activeSubsection, setActiveSubsection] = useState('budget-increase');

  const subsections = [
    {
      id: 'budget-increase',
      name: 'AUMENTO PPTO',
      icon: '💰',
      color: 'from-blue-600 to-indigo-600',
      component: MetaBudgetIncreaseSection
    },
    {
      id: 'campaign-tracking',
      name: 'SEGUIMIENTO CAMPAÑA',
      icon: '📊',
      color: 'from-orange-600 to-red-600',
      component: MetaCampaignTrackingSection
    },
    {
      id: 'balance-reduction',
      name: 'CLIENTES QUE BAJAN SALDO',
      icon: '📉',
      color: 'from-green-600 to-emerald-600',
      component: MetaBalanceReductionSection
    },
    {
      id: 'no-contact',
      name: 'BAJARON O SIN CONTACTOS',
      icon: '📵',
      color: 'from-yellow-600 to-amber-600',
      component: MetaNoContactSection
    },
    {
      id: 'cost-increase',
      name: 'AUMENTO DE COSTO POR MENSAJE',
      icon: '💸',
      color: 'from-purple-600 to-violet-600',
      component: MetaCostIncreaseSection
    },
    {
      id: 'verifications',
      name: 'VERIFICACION DE CUENTAS',
      icon: '✅',
      color: 'from-teal-600 to-cyan-600',
      component: MetaVerificationsSection
    },
    {
      id: 'no-answer',
      name: 'CLIENTES QUE NO CONTESTAN',
      icon: '🔇',
      color: 'from-orange-600 to-red-600',
      component: MetaNoAnswerSection
    },
    {
      id: 'budget-review',
      name: 'REVISIÓN DE PRESUPUESTO',
      icon: '💰',
      color: 'from-blue-600 to-purple-600',
      component: MetaBudgetReviewSection
    }
  ];

  const activeSubsectionData = subsections.find(sub => sub.id === activeSubsection);
  const ActiveComponent = activeSubsectionData?.component;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-6 text-white">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold flex items-center">
              <span className="mr-3">📱</span>
              Meta
            </h1>
            <p className="text-blue-100 mt-2">
              Gestión integral de campañas y seguimiento de Meta Ads
            </p>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold">{subsections.length}</div>
            <div className="text-blue-100">Subsecciones</div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex flex-wrap" aria-label="Tabs">
            {subsections.map((subsection) => (
              <button
                key={subsection.id}
                onClick={() => setActiveSubsection(subsection.id)}
                className={`py-4 px-4 border-b-2 font-medium text-sm whitespace-nowrap transition-all duration-200 ${
                  activeSubsection === subsection.id
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <span className="text-lg">{subsection.icon}</span>
                  <span className="hidden sm:inline">{subsection.name}</span>
                  <span className="sm:hidden">{subsection.name.split(' ')[0]}</span>
                </div>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Active Subsection Content */}
      <div className="min-h-screen">
        {ActiveComponent && (
          <div className="space-y-6">
            {/* Subsection Header */}
            <div className={`bg-gradient-to-r ${activeSubsectionData.color} rounded-xl p-6 text-white`}>
              <div className="flex items-center">
                <span className="text-4xl mr-4">{activeSubsectionData.icon}</span>
                <div>
                  <h2 className="text-2xl font-bold">{activeSubsectionData.name}</h2>
                  <p className="text-white/80 mt-1">
                    Gestión y seguimiento especializado para Meta Ads
                  </p>
                </div>
              </div>
            </div>

            {/* Subsection Component */}
            <ActiveComponent currentUser={currentUser} />
          </div>
        )}
      </div>
    </div>
  );
};

export default MetaSection;
